module.exports = __webpack_public_path__ + "img/icon-sites.29b9622b.svg";